import App from './App'
import { BrowserRouter } from 'react-router-dom'
import React from 'react'
import { hydrateRoot } from 'react-dom/client'

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log(`Service Worker registered! Scope: ${registration.scope}`)
      })
      .catch(err => {
        console.log(`Service Worker registration failed: ${err}`)
      })
  })
}

hydrateRoot(
  document.getElementById('root'),
  <BrowserRouter>
    <App />
  </BrowserRouter>
)

if (module.hot) {
  module.hot.accept()
}
